import {
  Card, Button, DialogTitle, Snackbar, DialogActions, Backdrop,
  TableCell, TableContainer, FormControl, Select,
  Table, Checkbox, FormControlLabel, FormLabel, FormGroup, FormHelperText,
  TableRow, Box,
  TableBody,
  TableHead, Typography, ListItemText, ListItemIcon, ListItem, DialogContent, List,
  Dialog, CardContent, CardHeader, Container, Grid, IconButton, TextField,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import ListItemButton from '@material-ui/core/ListItemAvatar';
import Divider from '@material-ui/core/Divider';
import FolderIcon from '@material-ui/icons/Folder';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import Alert from 'src/components/Alert';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFileOutlined';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import Tarihce from 'src/views/History';
import GamesOutlinedIcon from '@material-ui/icons/GamesOutlined';
import ExtensionIcon from '@material-ui/icons/Extension';
import UploadFile from '../../components/UploadFile';
import ExpandableComment from 'src/components/ExpandableComment';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  rootlist: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550,
  },
  rootlistsag: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500,
  },

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650,
  },
  content: {
    minHeight: 550,
  },
  chatSection: {
    width: '100%',
  },
  container: {
    maxHeight: '100%',
    maxWidth: '100%',
    minWidth: '100%'
  },
  container1: {
    maxHeight: 630,
    maxWidth: '100%',
    minWidth: '100%'
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: {
    margin: theme.spacing(1),
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(-1),
    color: theme.palette.grey[500],
  },
  formControl: {
    margin: theme.spacing(3)
  },
  cardscontent3: {
    minHeight: 50
  },
  cardscontent2: {
    height: 600
  },
  spanText: {
    lineHeight: 2,
    fontFamily: 'Roboto',
    fontSize: 14
  },
  textInput: {
    border: 'none',
    borderBottom: '1px solid #FF9800',
    padding: '2px 5px',
    outline: 'none',
    fontWeight: 'bold',
  },
  textInput2: {
    border: 'none',
    borderBottom: '1px solid #FF9800',
    padding: '2px 5px',
    outline: 'none',

  },
  responsiveContainer: {
    [theme.breakpoints.between("md", "lg")]: {
      maxHeight: "70vh",
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "60vh",
      overflow: 'scroll'
    }
  }
}));
function Confirm() {
  const classes = useStyles();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const SessionUser = getUser();
  const [durumId, setDurumId] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [applicationId, setApplicationId] = useState(0);
  const [documentType, setDocumentType] = useState(0);
  const [Required, setRequired] = useState(false);
  const [yorumAciklama, setYorumAciklama] = useState('');
  const [findeksYorumAciklama, setFindeksYorumAciklama] = useState('');
  const [generalData, setGeneralData] = useState([]);
  const [singlePopUp, setSinglePopUp] = useState(false);
  const [filePopUp, setFilePopUp] = useState(false);
  const [fileList, setFileList] = React.useState([])
  const [findeksPopUp, setFindeksPopUp] = useState(false);
  const [findeksInfo, setFindeksInfo] = useState(0)
  const [tarihcePopUp, setTarihcePopUp] = useState(false);
  const [todoData, setTodoData] = useState([]);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState([]);
  const [selectedYSOnay, setSelectedYSOnay] = useState([]);
  const [finalPopUp, setFinalPopUp] = useState(false);
  const [checkedMenu, setCheckedMenu] = useState([]);
  const [moyOnayPopUp, setMoyOnayPopUp] = useState(false);
  const [byOnayPopUp, setBYOnayPopUp] = useState(false);
  const [openType, setOpenType] = useState(0);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [fileTypeData, setFileTypeData] = React.useState([]);
  const [state, setState] = React.useState({
    kural1: false,
    kural2: false,
    kural3: false,
    kural4: false
  });
  const [acilisTipId, setAcilisTipId] = useState(null)
  const [confirmPopUpWithServiceInformation, setConfirmPopUpWithServiceInformation] = useState(false);
  const [confirmServiceAreaName, setConfirmServiceAreaName] = useState('');
  const [confirmServiceOpeningType, setConfirmServiceOpeningType] = useState();
  const [confirmServiceDetailName, setConfirmServiceDetailName] = useState('');
  const [confirmedServiceNumber, setConfirmedServiceNumber] = useState('');
  const [confirmedServiceName, setConfirmedServiceName] = useState('');
  const [confirmedShipmentCode, setConfirmedShipmentCode] = useState('');
  const [confirmedServicePhone, setConfirmedServicePhone] = useState('');
  const [confirmedServicePhone2, setConfirmedServicePhone2] = useState('');
  const [confirmedServiceEmail, setConfirmedServiceEmail] = useState('');
  const [confirmedServiceOwnerEmail, setConfirmedServiceOwnerEmail] = useState('');
  const [serviceType, setServiceType] = useState('');

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const { kural1, kural2, kural3, kural4 } = state;

  const Bosalt = () => {
    
    setState({
      kural1: false,
      kural2: false,
      kural3: false,
      kural4: false
    });
    setDurumId(0);
    setApplicationId(0);
    setDocumentType(0);
    setRequired(false);
    setYorumAciklama('');
    setFindeksYorumAciklama('');
    setGeneralData([]);
    setSinglePopUp(false);
    setFilePopUp(false);
    setFileList([]);
    setFindeksPopUp(false);
    setFindeksInfo(0);
    setTarihcePopUp(false);
    setTodoData([]);
    setSelectedWorkOrderId([]);
    setSelectedYSOnay([]);
    setFinalPopUp(false);
    setCheckedMenu([]);
    setMoyOnayPopUp(false);
    setBYOnayPopUp(false);
    setOpenType(0);
    setFileTypeData([]);
    setAcilisTipId(null);
    setConfirmPopUpWithServiceInformation(false);
    setConfirmServiceAreaName('');
    setConfirmServiceOpeningType();
    setConfirmServiceDetailName('');
    setConfirmedServiceNumber('');
    setConfirmedServiceName('');
    setConfirmedShipmentCode('');
    setConfirmedServicePhone('');
    setConfirmedServicePhone2('');
    setConfirmedServiceEmail('');
    setConfirmedServiceOwnerEmail('');
    setServiceType('');
    handleFileClose(1);
    const searchParams1 = new URLSearchParams(window.location.search);
    const myParam1= searchParams1.get('id');
    if (myParam1) {
      setSelectedIndex(parseInt(myParam1));
    }


  }


  useEffect(() => {
    handleFileClose(1);
    const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('id');
    if (myParam) {
      setSelectedIndex(parseInt(myParam));
    }
    let mounted = true;
    return () => {
      mounted = false;
    };
  }, [SessionUser.TopServiceShopCode, SessionUser.TechnicianId]);

  const handleFileClose = (dataUri) => {
    setLoading(true);
    axios.get(`/GetArtemisPortalOnay/${SessionUser.TopServiceShopCode}`)
      .then((response) => {
        setLoading(false);
        const res = response.data;
        setGeneralData(res);
      }).catch(error => {
        setLoading(false);
      });
  }

  const handleSaveFindeks = (itemValue) => {
    if (findeksInfo == 0) {
      setresponseMessage('Lütfen Findeks Durumunu seçiniz!...')
      setUyariTip("error");
      setUyari(true);
      return;
    }
    if (!findeksYorumAciklama) {
      setRequired(true);
      return;
    }
    const data = [{
      Id: selectedIndex,
      FindeksYorum: findeksYorumAciklama,
      UserId: "",//okta
      Role_Id: 0,
      Durum: durumId,
      Findeks_Bilgi: findeksInfo,
      Onay: itemValue
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetFindeksOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setFindeksPopUp(false);
        setFindeksYorumAciklama('');
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setFindeksPopUp(false);
        handleFileClose(1);
        setFindeksYorumAciklama('');
      }
    }).catch(error => {
      setLoading(false);
      setFindeksPopUp(false);
    });
  }

  const handleSave = () => { 
    if (checkedMenu.length < todoData.length && durumId == 14) {
      setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
      setUyariTip("error");
      setUyari(true);
      return;
    }
    if (((durumId == 5 && kural1 == false) || (durumId == 5 && kural2 == false) || (durumId == 5 && kural3 == false) || (durumId == 5 && kural4 == false && serviceType == "Ticari Servis")) && acilisTipId != 5) {
      setresponseMessage("Lütfen BY Onay Adımlarını tamamlayınız!...")
      setUyariTip("error");
      setUyari(true);
      handleFileType(selectedIndex);
      setBYOnayPopUp(true);

      return;
    }
    if (!yorumAciklama) {
      setRequired(true);
      return
    }
    const data = [{
      Id: selectedIndex,
      Yorum: yorumAciklama,
      UserId: "",
      Role_Id: 0,
      Durum: durumId,
      OpenType: openType
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetArtemisPortalOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
      }
      if (res.ErrorCode === '0') {
      
        setresponseMessage(res.ErrorDescription);
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        Bosalt();
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
    });
  }

  const handleSaveWithServiceInformation = () => {
    if (confirmedServiceNumber == '') {
      setresponseMessage("Lütfen Servis Kodu Bilgisini Giriniz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }
    if (confirmedServiceName == '') {
      setresponseMessage("Lütfen Servis Adı Bilgisini Giriniz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }
    if (setConfirmedShipmentCode == '') {
      setresponseMessage("Lütfen Yedek Parça Sevkiyat Kodu Bilgisini Giriniz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }
    //servis kodu sadece rakam olmalı
    if (!/^\d+$/.test(confirmedServiceNumber)) {
      setresponseMessage("Servis Kodu Bilgisinde sadece rakam kullanılabilir!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }

    // const nonFormattedConfirmedServicePhone = confirmedServicePhone.replace(/\D/g, '');
    // //check confirmedServicePhone is valid format "(###) ###-####"
    // if (nonFormattedConfirmedServicePhone == '' || nonFormattedConfirmedServicePhone.length != 10) {
    //   setresponseMessage("Girmiş olduğunuz telefon numarası geçersiz!...")
    //   setUyariTip("error");
    //   setUyari(true);
    //   return;
    // }

    //check confirmedServiceEmail is valid email format
    if (confirmedServiceEmail != '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(confirmedServiceEmail)) {
      setresponseMessage("Girmiş olduğunuz e-mail adresi geçersiz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }

    //check confirmedServiceOwnerEmail is valid email format
    if (confirmedServiceOwnerEmail != '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(confirmedServiceOwnerEmail)) {
      setresponseMessage("Girmiş olduğunuz ys sahibi e-mail adresi geçersiz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }




    var comment = '';
    confirmServiceOpeningType == "Yeni Açılış"
      ? comment = `${confirmServiceAreaName}'ye bağlı ${confirmedServiceNumber} kodlu ${confirmedServiceName} servisinin SAP’de açılması için yardımınızı rica ederiz.`
      : confirmServiceOpeningType == "Şube Açılışı"
        ? comment = `${confirmServiceAreaName}'ye bağlı ${confirmServiceDetailName} servisinin şubesi olarak ${confirmedServiceNumber} kodlu ${confirmedServiceName} açılacaktır. Yedek parça sevkiyat kodu ${confirmedShipmentCode}. SAP açılışı için yardımınızı rica ederiz.`
        : confirmServiceOpeningType == "Birleşme"
          ? comment = `${confirmServiceAreaName}'ye bağlı ${confirmServiceDetailName} servis(ler)i ${confirmServiceOpeningType} sebebiyle ${confirmedServiceNumber} kodlu ${confirmedServiceName} servisi olarak açılacaktır. SAP’de açılması için yardımınızı rica ederiz.`
          : comment = `${confirmServiceAreaName}'ye bağlı ${confirmServiceDetailName} servisi ${confirmServiceOpeningType} sebebiyle ${confirmedServiceNumber} kodlu ${confirmedServiceName} servisi olarak yeniden açılacaktır. SAP’de açılması için yardımınızı rica ederiz.`;

    comment = comment + "</br></br><b>Telefon: </b>" + confirmedServicePhone + "</br><b>Telefon2: </b>" + confirmedServicePhone2 + "</br><b>E-mail: </b>" + confirmedServiceEmail + "</br><b>Ys Sahibi E-mail: </b>" + confirmedServiceOwnerEmail + "</br>";

    const data = [{
      Id: selectedIndex,
      Yorum: comment,
      UserId: "",
      Role_Id: 0,
      Durum: durumId,
      OpenType: openType,
      ServiceNumber: confirmedServiceNumber
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetArtemisPortalOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setConfirmPopUpWithServiceInformation(false);
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setConfirmPopUpWithServiceInformation(false);
        handleFileClose(1);
        setSelectedWorkOrderId([]);
        setSelectedYSOnay([]);
        setState({
          kural1: false,
          kural2: false,
          kural3: false,
          kural4: false
        });
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
    });
  }

  const handleActionPopUp = (row) => {
    if (row.DURUM_ID == 5) {
      setSelectedIndex(row.ID);
      handleFileType(row.ID);
      setBYOnayPopUp(true);
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    else if (row.DURUM_ID == 10) {
      setSelectedIndex(row.ID);
      setMoyOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    else if(row.DURUM_ID == 14){
      setSelectedIndex(row.ID);
      setFinalPopUp(true);
      getApolloTodo();
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
  }

  const handleSinglePopUp = (row) => {
    if (row.DURUM_ID == 2 && row.ACILIS_TIP_ID != 5) {
      setSelectedIndex(row.ID);
      setDurumId(row.DURUM_ID);
      setFindeksPopUp(true);
      setFindeksYorumAciklama('');
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    else if (row.DURUM_ID == 10 || (row.DURUM_ID == 5 && row.ACILIS_TIP_ID == 5)) {
      setSelectedIndex(row.ID);
      setConfirmServiceOpeningType(row.ACILIS_TIP);
      setConfirmServiceDetailName(row.SERVIS_DETAYLI_AD);
      setConfirmServiceAreaName(row.BOLGE_AD);
      setConfirmPopUpWithServiceInformation(true);
      //setYorumAciklama('.....ne bağlı ... kodlu .... servisinin SAP’de açılması için yardımınızı rica ederiz.');
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    // else if ((row.DURUM_ID == 5 && row.ACILIS_TIP_ID == 5)) {
    //   getMoyOnayText(row)
    // }
    else if (row.DURUM_ID == 14) {
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setDurumId(row.DURUM_ID);
      setYorumAciklama('');
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    else {
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setYorumAciklama('');
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
  }

  const handleDocumentDownload = (row) => {
    setApplicationId(row.ID);
    setDocumentType(row.ACILIS_TIP_ID)
  }

  const handleFilePopUp = (row) => {
    setSelectedIndex(row.ID);
    getReceiptAllFiles(row.ID)
    setFilePopUp(true);
  }

  const handleYorum = (row) => {
    setSelectedIndex(row.ID);
    setTarihcePopUp(true);
  }

  const getReceiptAllFiles = (receiptNumber) => {
    setFileList([]);
    setLoading(true);
    if (!receiptNumber) {
      return;
    }
    var images = []
    axios.get("/getReceiptAllFiles/" + receiptNumber + '/' + 1, {
      responseType: 'arrayBuffer'
    }).then(response => {
      setFileList(response.data)
      setLoading(false)
    });
  }

  const getApolloTodo = () => {
    setLoading(true)
    axios.get("/GetApolloTodoList/1").then((response) => {
      const Todo = response.data;
      if (Todo.length === 0) {
        setTodoData([]);
        setLoading(false);
      } else {
        setTodoData(Todo);
        setLoading(false);
      }
    });
  }

  // const getMoyOnayText = (row) => {
  //   setLoading(true)
  //   axios.get("/GetMOYOnayText/" + row.ID).then((response) => {
  //     const text = response.data;
  //     if (text.length === 0) {
  //       setYorumAciklama('');
  //       setLoading(false);
  //     } else {
  //       setLoading(false);
  //       setYorumAciklama(text);
  //       setSelectedIndex(row.ID);
  //       setSinglePopUp(true);
  //       setDurumId(row.DURUM_ID);
  //       setOpenType(row.ACILIS_TIP_ID)

  //     }
  //   });
  // }

  const setCheckMenuItem = (id) => {
    if (checkedMenu?.includes(id)) {
      var checkedMenuControl = checkedMenu?.filter((item) => item !== id);
      setCheckedMenu(checkedMenuControl);
    }
    else {
      setCheckedMenu([...checkedMenu, id]);
    }
  }

  const setNewWindowOpen = (item) => {
    //get file data from GetReceiptFilesSpecial api
    setLoading(true);
    axios.get(`/GetReceiptFilesSpecial/${item.DOSYA_ID}`)
      .then((response) => {
        const res = response.data[0];
        var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
        if (res?.DOSYA_TIPI?.includes('image')) {
          var image = new Image();
          image.src = FileData;
          var w = window.open("");
          w.document.write(image.outerHTML);
          w.document.title = res.DOSYA_ADI;
          w.document.close();
        } else {
          var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
          openBlobInNewTab(blobData);
        }
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });

    // var FileData = `data:${item.DOSYA_TIPI};base64,${item.DOSYA_DATA}`
    // if (item?.DOSYA_TIPI?.includes('image')) {
    //   var image = new Image();
    //   image.src = FileData;
    //   var w = window.open("");
    //   w.document.write(image.outerHTML);
    //   w.document.title = item.DOSYA_ADI;
    //   w.document.close();
    // } else {
    //   var blobData = base64ToBlob(item.DOSYA_DATA, "application/pdf");
    //   openBlobInNewTab(blobData);
    // }
  }

  function base64ToBlob(base64Data, contentType) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  function openBlobInNewTab(blobData) {
    var newTab = window.open();
    var objectUrl = URL.createObjectURL(blobData);
    newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleSaveTodoList = (itemValue) => {
    if (checkedMenu.length < todoData.length) {
      setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
      setUyariTip("error");
      setUyari(true);
      return;
    }
    const data = {
      ApplicationId: selectedIndex,
      Confirm: true,
      UserId: "",
      OpenCloseType: 1
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetTodoOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode == '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setFinalPopUp(false);
        handleFileClose(1);
      }
      if (res.ErrorCode == 0) {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setFinalPopUp(false);
        handleFileClose(1);
        checkedMenu([]);
      }
    }).catch(error => {
      setLoading(false);
      setFinalPopUp(false);
      handleFileClose(1);
    });
  }
  const handleFileType = (basvuruId) => {
    axios.get(`/GetFileTypeById/` + basvuruId, {
      responseType: 'arrayBuffer'
    })
      .then((response) => {
        const res = response.data;
        setFileTypeData(res);
      }).catch(error => {
      });
  }

  const handleReject = () => {
    if ((durumId == 2 && !findeksYorumAciklama && acilisTipId != 5)) {
      setRequired(true);
      return
    }
    if ((!yorumAciklama && durumId != 10 && durumId != 2)) {
      setRequired(true);
      return
    }

    var comment = '';
    if (durumId == 2) {
      comment = findeksYorumAciklama;
    }
    else if (durumId == 10) {
      comment = 'Moy tarafından reddedildi.';
    }
    else {
      comment = yorumAciklama;
    }
    const data = [{
      Id: selectedIndex,
      Yorum: comment,
      UserId: "",
      Role_Id: 0,
      Durum: durumId,
      OpenType: openType
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetRejectBasvuru', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setFindeksPopUp(false);
        setConfirmPopUpWithServiceInformation(false)
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setFindeksPopUp(false);
        setConfirmPopUpWithServiceInformation(false)
        handleFileClose(1);
        setSelectedWorkOrderId([]);
        setSelectedYSOnay([]);
        setState({
          kural1: false,
          kural2: false,
          kural3: false,
          kural4: false
        });
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
      setFindeksPopUp(false);
      setConfirmPopUpWithServiceInformation(false)
    });
  }

  const formatPhoneNumber = (inputValue) => {
    const cleaned = ('' + inputValue).replace(/\D/g, '');
    if (inputValue.length > 14) {
      return inputValue.substring(0, 16);
    }

    let formatted = '';
    for (let i = 0; i < cleaned.length; i++) {
      if (i === 0) {
        formatted += '(';
      } else if (i === 3) {
        formatted += ') ';
      } else if (i === 6) {
        formatted += ' - ';
      }
      formatted += cleaned.charAt(i);
    }

    return formatted;
  };

  const handlePhoneInputChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    setConfirmedServicePhone(formattedValue);
  };

  const handlePhoneInputChange2 = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    setConfirmedServicePhone2(formattedValue);
  };

  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}>
        </Alert>
      </Snackbar>
      <Container className={classes.container1} maxWidth="xl">
        <Card >
          <CardHeader title="Onay Bekleyenler" />
          <Divider />
          <CardContent >
            <TableContainer>
              <Table stickyHeader aria-label="sticky table" size="small"  >
                <TableHead style={{ overflowWrap: 'break-word' }}>
                  <TableRow>
                    <TableCell align="left">AçılışTipi</TableCell>
                    <TableCell align="left">Son Onay Veren</TableCell>
                    <TableCell align="left">Onay Beklenen</TableCell>
                    <TableCell align="left">BölgeKoduAdı</TableCell>
                    <TableCell align="left">İl-İlçe</TableCell>
                    <TableCell align="left">ServisTipi</TableCell>
                    <TableCell align="left">Servis Bilgi</TableCell>
                    <TableCell align="left">Açılış Detayı</TableCell>
                    <TableCell align="left">Servis Konumu</TableCell>
                    <TableCell align="left">Findeks Yorumu</TableCell>
                    <TableCell align="left">Yorumlar</TableCell>
                    <TableCell align="left">Belgeler</TableCell>
                    <TableCell align="left">Aksiyonlar</TableCell>
                    <TableCell align="left">Onay/Red</TableCell>
                    <TableCell align="left" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {generalData?.length ? generalData.map((row, index) => (
                    <TableRow key={index}
                      style={row.ID === selectedIndex ? { backgroundColor: "#FF9800" }
                        : {}}
                    >
                      <TableCell align="left">{row.ACILIS_TIP}</TableCell>
                      <TableCell align="left">{row.DURUM}</TableCell>
                      <TableCell align="left">{row.SONRAKI_ADIM_ACIKLAMA}</TableCell>
                      <TableCell align="left">{row.BOLGE_AD}</TableCell>
                      <TableCell align="left">{row.IL_ILCE}</TableCell>
                      <TableCell align="left">{row.SERVIS_TIP}</TableCell>
                      <TableCell align="left">
                        <ExpandableComment
                          Comment={row.SERVIS_BILGI}
                          CommentLimit={100}
                          DarkColor={selectedIndex != row.ID ? false : true} />
                      </TableCell>
                      <TableCell align="left">{row.ACILIS_TIP_ID == 1 ? '-' :
                        row.ACILIS_TIP_ID == 2 ? <><b>Devir olan servis: </b> {row.DEVIR}</> :
                          row.ACILIS_TIP_ID == 3 ? <><b>Şirketleşen servis: </b> {row.SIRKETLESME}</> :
                            row.ACILIS_TIP_ID == 4 ? <><b>Birleşen servisler: </b> {row.BIRLESME}</> :
                              <><b>Şube Açan Servis: </b> {row.SUBELESME}</>}</TableCell>
                      <TableCell align="left">{row.SERVIS_KONUMU}</TableCell>
                      <TableCell align="left">{row.FINDEKS_YORUM}</TableCell>
                      <TableCell align="left">
                        <IconButton
                          size="small"
                          onClick={() => handleYorum(row)}
                          style={{ backgroundColor: '#19ecff', color: 'white' }}
                        >
                          <CommentOutlinedIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left">
                        <IconButton
                          size="small"
                          onClick={() => handleFilePopUp(row)}
                          style={{ backgroundColor: '#FF7F00', color: 'white' }}
                        >
                          <AttachFileOutlinedIcon />
                        </IconButton>
                      </TableCell>


                      {(row.DURUM_ID == 5 || row.DURUM_ID == 10) && row.ACILIS_TIP_ID != 5 ?
                        <TableCell align="left">
                          <IconButton
                            size="small"

                            onClick={() => {
                              handleActionPopUp(row)
                              setState({
                                kural1: false,
                                kural2: false,
                                kural3: false,
                                kural4: false
                              });
                            }}
                            style={{ backgroundColor: '#FF4F00', color: 'white' }}
                          >
                            <ExtensionIcon />
                          </IconButton>
                        </TableCell>
                        :(row.DURUM_ID == 14)?
                        <TableCell align="left">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setAcilisTipId(row.ACILIS_TIP_ID)
                            handleActionPopUp(row)
                          }}
                          style={{ backgroundColor: '#FF4F00', color: 'white' }}
                        >
                          <ExtensionIcon />
                        </IconButton>
                      </TableCell>
                        :<TableCell align="left" />
                      }

                        <TableCell align="left">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAcilisTipId(row.ACILIS_TIP_ID)
                              handleSinglePopUp(row)
                            }}
                            style={{ backgroundColor: '#32CD32', color: 'white' }}
                          >
                            <DoneAllIcon />
                          </IconButton>
                        </TableCell>
                    </TableRow>
                  )) : <TableRow />}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
          <Dialog
            open={singlePopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setSinglePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="sm" spacing={1}>
              <IconButton
                onClick={() => {
                  setSinglePopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'Onayla & Reddet'} />
                <Divider />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        id="desc"
                        autoComplete="no"
                        multiline
                        error={yorumAciklama?.length > 0 ? false : Required}
                        rows={10}
                        value={yorumAciklama}
                        onChange={(event) => setYorumAciklama(
                          event.target.value
                        )}
                        fullWidth
                        label='Yorum'
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <Divider />
            </Container>
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => handleReject()}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                Reddet
              </Button>
              <Button
                color="secondary"
                onClick={() => handleSave()}
                aria-label="save"
                component="span"
                variant="contained"
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={confirmPopUpWithServiceInformation}
            fullWidth
            maxWidth="sm"
            onClose={() => setConfirmPopUpWithServiceInformation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="sm" spacing={1}>
              <IconButton
                onClick={() => {
                  setConfirmPopUpWithServiceInformation(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'Onayla & Reddet'} />
                <Divider />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={1}>
                    <Box component="span" m="{1}" className={classes.spanText}>
                      {confirmServiceOpeningType == "Yeni Açılış" ?
                        <>
                          <b>{confirmServiceAreaName}</b>'ye bağlı <input type="text" name="name" className={classes.textInput} style={{ width: 50 }} onChange={(e) => setConfirmedServiceNumber(e.target.value)} autoComplete="new-password" /> kodlu <input type="text" name="name" className={classes.textInput} onChange={(e) => setConfirmedServiceName(e.target.value)} autoComplete="new-password" /> servisinin SAP’de açılması için yardımınızı rica ederiz.
                        </>
                        : confirmServiceOpeningType == "Şube Açılışı" ?
                          <>
                            <b>{confirmServiceAreaName}</b>'ye bağlı <b>{confirmServiceDetailName}</b> servisinin şubesi olarak <input type="text" name="name" className={classes.textInput} style={{ width: 50 }} onChange={(e) => setConfirmedServiceNumber(e.target.value)} autoComplete="new-password" /> kodlu  <input type="text" name="name" className={classes.textInput} onChange={(e) => setConfirmedServiceName(e.target.value)} autoComplete="new-password" /> açılacaktır. Yedek parça sevkiyat kodu <input type="text" name="name" className={classes.textInput} style={{ width: 100 }} onChange={(e) => setConfirmedShipmentCode(e.target.value)} autoComplete="new-password" />. SAP açılışı için yardımınızı rica ederiz.
                          </>
                          : confirmServiceOpeningType == "Birleşme" ?
                            <>
                              <b>{confirmServiceAreaName}</b>'ye bağlı <b>{confirmServiceDetailName}</b> servis(ler)i <b>{confirmServiceOpeningType}</b> sebebiyle <input type="text" name="name" className={classes.textInput} style={{ width: 50 }} onChange={(e) => setConfirmedServiceNumber(e.target.value)} autoComplete="new-password" /> kodlu  <input type="text" name="name" className={classes.textInput} onChange={(e) => setConfirmedServiceName(e.target.value)} autoComplete="new-password" /> servisi olarak açılacaktır. SAP’de açılması için yardımınızı rica ederiz.
                            </>
                            :
                            <>
                              <b>{confirmServiceAreaName}</b>'ye bağlı <b>{confirmServiceDetailName}</b> servisi <b>{confirmServiceOpeningType}</b> sebebiyle <input type="text" name="name" className={classes.textInput} style={{ width: 50 }} onChange={(e) => setConfirmedServiceNumber(e.target.value)} autoComplete="new-password" /> kodlu  <input type="text" name="name" className={classes.textInput} onChange={(e) => setConfirmedServiceName(e.target.value)} autoComplete="new-password" /> servisi olarak yeniden açılacaktır. SAP’de açılması için yardımınızı rica ederiz.
                            </>
                      }
                      <br />
                      <br />
                      <b>Telefon:</b>
                      <input type="text"
                        placeholder="(###) ###-####"
                        value={confirmedServicePhone}
                        className={classes.textInput2}
                        style={{ width: 110 }}
                        onChange={handlePhoneInputChange}
                        autoComplete="new-password"
                      />
                      <br />
                      <b>Telefon 2 :</b>
                      <input type="text"
                        placeholder="(###) ###-####"
                        value={confirmedServicePhone2}
                        className={classes.textInput2}
                        style={{ width: 110 }}
                        onChange={handlePhoneInputChange2}
                        autoComplete="new-password"
                      />
                      <br />
                      <b>E-mail:</b>
                      <input type="text"
                        className={classes.textInput2}
                        value={confirmedServiceEmail}
                        placeholder="OrnekMail@arcelik.com"
                        style={{ width: 200 }}
                        onChange={(e) => setConfirmedServiceEmail(e.target.value)}
                        autoComplete="new-password"
                      />
                      <br />
                      <b>YS Sahibi E-mail:</b>
                      <input type="text"
                        className={classes.textInput2}
                        value={confirmedServiceOwnerEmail}
                        placeholder="OrnekMail@arcelik.com"
                        style={{ width: 200 }}
                        onChange={(e) => setConfirmedServiceOwnerEmail(e.target.value)}
                        autoComplete="new-password"
                      />
                    </Box>
                  </Grid>
                </CardContent>
              </Card>
              <Divider />
            </Container>
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => handleReject()}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                Reddet
              </Button>
              <Button
                color="secondary"
                onClick={() => handleSaveWithServiceInformation()}
                aria-label="save"
                component="span"
                variant="contained"
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={findeksPopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setFindeksPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="sm" spacing={1}>
              <IconButton
                onClick={() => {
                  setFindeksPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={' Findeks Onayla & Reddet'} />
                <Divider />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12} >
                      <FormControl
                        fullWidth
                        size="small"
                        variant="outlined"
                      >
                        <Select
                          fullWidth
                          native
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={findeksInfo}
                          // disabled={readonly}
                          onChange={(event) => { setFindeksInfo(event.target.value) }}
                        >
                          <option value="0" defaultValue="0">Findeks Durumu Seçiniz!...</option>
                          <option value={1}>Risk Yok</option>
                          <option value={4}>Az Riskli</option>
                          <option value={2}>Riskli</option>
                          <option value={3}>Yüksek Riskli</option>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        id="desc"
                        autoComplete="no"
                        multiline
                        error={findeksYorumAciklama?.length > 0 ? false : Required}
                        rows={3}
                        value={findeksYorumAciklama}
                        onChange={(event) => setFindeksYorumAciklama(
                          event.target.value
                        )}
                        fullWidth
                        label='Findeks Yorum'
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <Divider />
            </Container>
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => handleReject()}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                Reddet
              </Button>
              <Button
                color="secondary"
                onClick={() => handleSaveFindeks(1)}
                aria-label="save"
                component="span"
                variant="contained"

                endIcon={<CheckCircleOutlineIcon />}
                style={{ backgroundColor: '#008000', color: 'white' }}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={filePopUp}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
          >
            <DialogContent>
              <Grid container spacing={2}>
                <List>
                  {fileList?.length ? fileList?.map((item, index) => (
                    <ListItem key={item.DOSYA_ID}>

                      <ListItemButton
                        style={{ display: 'flex', cursor: 'pointer' }}
                      >
                        <ListItemIcon>

                          <FolderIcon style={{ color: '#424242' }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={<Typography type="body2"> {item.DOSYA_ADI}</Typography>}
                          onClick={() => {
                            setNewWindowOpen(item);
                            // setShowFile(true)
                            // setSelectedFile(row)
                          }}
                        />
                        <ListItemText
                          primary={item.ContentType}
                        />
                      </ListItemButton>
                    </ListItem>
                  )) : !loading ? "Dosya Bulunmamaktadır." : "Dosyalar Yükleniyor..."}
                </List>

              </Grid>
            </DialogContent>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={() => {
                  setFilePopUp(false);
                }}
                aria-label="close"
                component="span"
                variant="contained"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
          <Dialog
            open={tarihcePopUp}
            fullWidth
            maxWidth="lg"
            onClose={event => setTarihcePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
            <DialogContent>
              <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={1} />
            </DialogContent>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={event => setTarihcePopUp(false)}
                aria-label="upload picture"
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
          <Dialog
            open={finalPopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setFinalPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="sm" spacing={1}>
              <IconButton
                onClick={() => {
                  setFinalPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'Süreci Sonlandır'} />
                <Divider />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <TableContainer>
                        <Table size="small" aria-label="a dense table">
                          <TableBody>
                            {

                              todoData?.map((item) => (
                                <TableRow>
                                  <TableCell align="left" style={{ width: '50px' }}>
                                    <FormControlLabel
                                      value="top"
                                      control={(
                                        <Checkbox
                                          color="primary"
                                          checked={checkedMenu.includes(item?.ID) ? true : false}
                                          onChange={() => setCheckMenuItem(item?.ID)}
                                        />
                                      )}
                                    />
                                  </TableCell>
                                  <TableCell align="left">
                                    {item.ACIKLAMA}
                                  </TableCell>
                                </TableRow>
                              ))
                            }
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Dialog
            open={byOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setBYOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setBYOnayPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'BY Onay Aksiyonlar'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={6} sm={6}>
                      <CardContent className={classes.cardscontent3}>
                        <FormControl component="fieldset" className={classes.formControl}>
                          <FormLabel component="legend">
                            Servis açılış süreci için aşağıdaki adımları tamamladınız mı?
                          </FormLabel>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox checked={kural1} onChange={handleChange} name="kural1" />
                              }
                              label="Tabela temini için MOY ile görüşüldü mü?"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox checked={kural2} onChange={handleChange} name="kural2" />
                              }
                              label="Yetkili Servis Sözleşmesi MOY'a ulaştırılmak üzere kargoya verildi mi?"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox checked={kural3} onChange={handleChange} name="kural3" />
                              }
                              label="Yetkili servis adayının e-fatura kaydı tamamlandı mı?"
                            />
                            {(serviceType == "Ticari Servis") ? (
                              <FormControlLabel
                                control={
                                  <Checkbox checked={kural4} onChange={handleChange} name="kural4" />
                                }
                                label="13905 Belgesi (F Gaz belgesi) alındı mı?/Alınması konusunda Yetkili Servis adayına bilgi verildi mi?" />
                            ) : null}
                          </FormGroup>
                          <FormHelperText>
                            İşlemleri tamamlamadan devam edemezsiniz!!
                          </FormHelperText>
                        </FormControl>
                      </CardContent>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <CardContent className={classes.cardscontent2}>
                        <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1} documentTypeNumber={3}
                          openClose={1} />
                      </CardContent>
                    </Grid>
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setBYOnayPopUp(false)}
                >
                  Tamam
                </Button>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Dialog
            open={moyOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setMoyOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setMoyOnayPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'MOY Onay Adımları'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <Card className={classes.cards}>
                        <CardContent className={classes.cardscontent2}>
                          <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1} documentTypeNumber={4}
                            openClose={1} />
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setMoyOnayPopUp(false)}
                >
                  Tamam
                </Button>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Divider />
        </Card>
      </Container>
    </Page >
  );
}

export default Confirm;
